import { cn } from "@cloai/uikit";

export const STYLES = {
  card: {
    base: cn(
      "group/item @container relative flex size-full cursor-pointer overflow-hidden rounded-xl duration-300 select-none",
      "flex items-center justify-center bg-card duration-300",
      "hover:bg-[oklch(from_var(--color-card)_calc(l_+_0.1)_c_h)]",
      "active:scale-95 active:bg-[oklch(from_var(--color-card)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    variants: {
      square: "aspect-square",
      portrait: "aspect-[4/5] ",
      wide: "aspect-[920/603]",
    },
    animate: cn("mix-blend-exclusion"),
    image: cn(
      "pointer-events-none block size-full object-cover object-bottom duration-300",
      "group-hover/item:scale-103 group-hover/item:duration-800",
      "mask-b-from-50%",
    ),
    VIPoverlay: cn(
      "@container pointer-events-none absolute inset-0 flex items-center justify-center bg-card/30 backdrop-blur-xs",
    ),
    text: {
      base: cn("text-center font-bold text-balance text-card-foreground"),
      size: {
        default: cn("text-container-10"),
        small: cn("text-container-7"),
      },
      variant: {
        top: cn("absolute bottom-3"),
        bottom: cn("absolute bottom-3"),
      },
    },
  },
};
